import { Injectable } from '@angular/core';
import { Document, DocItems } from 'src/app/shared/document';

@Injectable({
  providedIn: 'root'
})
export class DocumentStackService {

  private stackIndex: number = 0;
  private docStack: Array<{ index: number, doc: Document }> =[];

  constructor() { }

  putDocument(doc: Document): number {
    this.docStack.push({ index: ++this.stackIndex, doc: doc });

    return this.stackIndex;
  }

  getDocument(id: number): Document {

    let doc: Document = null;

    let i = this.docStack.findIndex(e => e.index);

    if (i > -1) { doc = this.docStack[i].doc; }

    return doc;
  }
  delDocument(id: number): void {
    let i = this.docStack.findIndex(e => e.index);
    this.docStack.slice(i, 1);
  }
}
